import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    InvigilationExamItem,
    InvigilationItemInfo
} from "../../../service/exam";
import { useToggle } from "react-use";

interface InvigilationCtxProps {
    examId: string;
    setExamId(examId: string): void;
    examList: InvigilationExamItem[];
    dataSource: InvigilationItemInfo[];
    currentIndex: number;
    currentData?: InvigilationItemInfo;
    onSelect(index: number): void;
    reloadKey: boolean;
    reloadAll(): void;
}

export const InvigilationCtx = React.createContext<InvigilationCtxProps>({
    examList: [],
    dataSource: [],
    examId: "",
    setExamId() {},
    onSelect() {},
    reloadKey: false,
    currentIndex: 0,
    reloadAll() {}
});

interface InvigilationProviderProps {
    children: React.ReactNode;
    examList: InvigilationExamItem[];
    dataSource: InvigilationItemInfo[];
    examId: string;
    setExamId(examId: string): void;
}

export default function InvigilationProvider({
    children,
    examList,
    dataSource,
    examId,
    setExamId
}: InvigilationProviderProps) {
    const [selectIndex, setSelectIndex] = useState(0);

    useEffect(() => {
        if (dataSource.length === 0) return setSelectIndex(0);
        if (selectIndex <= dataSource.length - 1) return; // 已经手动选择的不自动选择第一项
        setSelectIndex(0);
    }, [dataSource, selectIndex]);

    // 切换考试自动选择第一项数据
    const onExamIdChange = useCallback((examId: string) => {
        setExamId(examId);
        setSelectIndex(0);
    }, []);

    const currentData = useMemo(
        () => dataSource[selectIndex],
        [selectIndex, dataSource]
    );

    const [reloadKey, toggleKey] = useToggle(false);

    return (
        <InvigilationCtx.Provider
            value={{
                examList,
                dataSource,
                examId,
                setExamId: onExamIdChange,
                currentIndex: selectIndex,
                currentData,
                reloadAll: toggleKey,
                reloadKey,
                onSelect: setSelectIndex
            }}>
            {children}
        </InvigilationCtx.Provider>
    );
}
